module.exports = __webpack_public_path__ + "static/images/styles/images/table/table-head-cell-sort-down.46b3ae6a.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/table/table-head-cell-sort-down.png
// module id = 3825
// module chunks = 11